import { sessionConnector } from 'shared/connectors'
import { SESSION } from 'store/types'

const success = data => ({
  type: SESSION.GET_SESSIONS_SUCCESS,
  payload: {
    data,
  },
})

const failure = () => ({
  type: SESSION.GET_SESSIONS_FAILURE,
})

const getSessions = params => async dispatch => {
  try {
    const { data } = await sessionConnector.getSessions(params)
    dispatch(success(data))
  } catch (err) {
    dispatch(failure())
  }
}

export default getSessions
